import { BridgeInterface } from '#ui-shared/stores/app-bridge/bridge-interface';
import type { BridgeActions, BridgeState } from '#ui-shared/stores/app-bridge/types';

interface NoraBridgeActions extends BridgeActions {
  goToCoordinates: (latitude: number, longitude: number, zoom?: number, operationId?: string | null) => void | Promise<void>;
}

interface NoraBridgeState extends BridgeState {}

export class NoraBridgeInterface extends BridgeInterface<NoraBridgeActions, NoraBridgeState> {
  constructor() {
    super(
      {
        goToCoordinates: async (latitude: number, longitude: number, zoom?: number, operationId?: string | null) => {
          console.warn(
            `Nora bridge action 'goToCoordinates' not (yet) registered. Coordinates: ${latitude}, ${longitude}, zoom: ${zoom ?? 'default'}, operationId: ${operationId ?? 'none'}`,
          );
        },
      },
      {},
    );
  }
}
